"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeDesignator = sanitizeDesignator;
exports.formatPinReference = formatPinReference;
exports.getLabelForPcbNode = getLabelForPcbNode;
exports.getNetUidForNode = getNetUidForNode;
exports.getNetNameForNode = getNetNameForNode;
exports.getLayerForNode = getLayerForNode;
exports.getLabelForRuleSet = getLabelForRuleSet;
const pcb_1 = require("../../pcb");
function sanitizeDesignator(name) {
    if (!name)
        return name;
    return name
        .replace(/[*]/g, "＊")
        .replace(/[[]/g, "［")
        .replace(/[\]]/g, "］")
        .replace(/[`]/g, "｀")
        .replace(/[~]/g, "～");
}
/**
 * Formats a component pin reference using the standard partDesignator:pinDesignator syntax.
 * Gracefully degrades to pinNumber when pinName is empty/null.
 * For component, falls back to componentName if designator is missing, then to "?" if neither is available.
 *
 * @param componentLabel - The component's reference designator (e.g., "U2", "R1")
 * @param pinName - The pin's name (e.g., "EN", "VCC") - preferred
 * @param pinNumber - The pin's number (e.g., "1", "4") - used as fallback when pinName is missing
 * @param componentName - The component's part name (e.g., "LM7805") - used as fallback when designator is missing
 * @returns A formatted string like "U2:EN" or "R1:1" or "LM7805:VIN"
 */
function formatPinReference(componentLabel, pinName, pinNumber, componentName) {
    const component = componentLabel || componentName || "?";
    const pin = pinName || pinNumber || "?";
    return `${component}:${pin}`;
}
function getLabelForPcbNode(node) {
    if (!node)
        return "Unknown";
    if (node.name === "Trace" && node.type === pcb_1.PcbNodeTypes.routeSegment) {
        return `Trace ${node.uid.substring(0, 4)}`;
    }
    return node.name ?? node.uid;
}
function getNetUidForNode(nodeUid, nodes) {
    const node = nodes[nodeUid];
    if (!node)
        return null;
    const nodeHasNet = node.type === pcb_1.PcbNodeTypes.pad || node.type === pcb_1.PcbNodeTypes.via || node.type === pcb_1.PcbNodeTypes.routeSegment;
    if (!nodeHasNet)
        return null;
    return node.bakedRules.effectiveNetId;
}
function getNetNameForNode(nodeUid, nodes) {
    const netUid = getNetUidForNode(nodeUid, nodes);
    return netUid ? nodes[netUid]?.name : null;
}
function getLayerForNode(nodeUid, nodes) {
    const node = nodes[nodeUid];
    if (!node)
        return null;
    if ("bakedRules" in node && node.bakedRules && "layer" in node.bakedRules) {
        const layer = node.bakedRules.layer;
        if (layer !== null && layer !== undefined) {
            return String(layer);
        }
    }
    return null;
}
function getLabelForRuleSet(nodeUid, ruleSets) {
    const ruleSet = ruleSets[nodeUid];
    if (!ruleSet)
        return null;
    return ruleSet.name ?? ruleSet.selector;
}
//# sourceMappingURL=common.js.map